/*部门管理 */
import { $http, buildHeaders } from "./index";

//获取部门详情
export const department_detail = (id) => {
  return $http.get("/admin/Department/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取部门树
export const department_tree = (params) => {
  return $http.get("/admin/Department/tree", {
    params,
  });
};

//添加部门
export const department_add = (data) => {
  return $http.post("/admin/Department/add", data, {
    headers: buildHeaders(3),
  });
};

//修改部门
export const department_edit = (data) => {
  return $http.post("/admin/Department/edit", data, {
    headers: buildHeaders(3),
  });
};

//部门启停
export const department_qt = (data) => {
  return $http.post("/admin/Department/updateStatus", data, {
    headers: buildHeaders(3),
  });
};

//删除部门
export const department_delete = (id) => {
  return $http.post(
    "/admin/Department/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
